import { Row, Col, Button, Tag, Typography } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import DataGrid from 'components/theme_components/DataGrid';
import HeroTitle from 'components/theme_components/HeroTitle';
import Title from 'components/Title';
import DF from 'DisplayFramework';
import {
  ArrowDownOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CheckOutlined,
  CloseOutlined,
  DownloadOutlined,
  EditOutlined,
  PlusOutlined,
  RightOutlined,
  SwapOutlined,
} from '@ant-design/icons';
import { useContext, useMemo, useState } from 'react';
import { FilterConfig, FilterValues } from 'types';
import { useQuery } from 'react-query';

import GetLabel from 'DisplayFramework/components/GetLabel';
import ModalSFS from 'components/theme_components/ModalSFS';
import IPen from 'icons/IPen';
import ExportXLS from 'components/theme_components/ExportXLS';
import StatCard from 'components/theme_components/StatCard';
import { dateToString } from 'utils/utilsSFS';
import moment from 'moment';
import { toRate } from 'utils/utils';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import { AuthContext } from 'components/Auth/Auth';
import Notifications from 'components/theme_components/Notifications';
import {
  findSIByAnyRefOrStatusOrDate,
  FindSIByAnyRefOrStatusOrDateParams,
} from 'services/supplierInvoice';
import InvoiceModal from './InvoiceModal';

export type InvoiceListProps = {
  color: string;
};

const InvoiceList = ({ color }: InvoiceListProps) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [addTaxeValue, setAddTaxeValue] = useState(false);
  const [filterValues, setFilterValues] = useState<FilterValues>({});
  const [selectedTaxeCode, setSelectedTaxeCode] = useState<any>('');
  const [modalVisible, setModalVisible] = useState(false);
  const [modalValidVisible, setmodalValidVisible] = useState(false);
  const [modalRejectVisible, setModalRejectVisible] = useState(false);

  const { isInspect } = useContext(AuthContext);
  const getSearchParams = () => {
    const formatteddatemax = filterValues.datemax
      ? moment(filterValues.datemax).date
      : '';
    const formatteddatemin = filterValues.datemin
      ? filterValues.datemin.format('YYYY-MM-DD')
      : '';
   

    return {
      clientname: filterValues.clientname || ('' as any),
      ctrreference: filterValues.ctrreference || ('' as any),
      datemax: formatteddatemax || ('' as any),
      datemin: formatteddatemin || ('' as any),
      deliveryreference: filterValues.deliveryreference || ('' as any),
      mgid: filterValues.mgid || ('' as any),
      orderreference: filterValues.orderreference || ('' as any),
      paystatus: filterValues.paystatus || ('' as any),
      sidocreference: filterValues.sidocreference || ('' as any),
      sireference: filterValues.sidocreference || ('' as any),
      sistatus: filterValues.sistatus || ('' as any),
      sistatus1: filterValues.itaxlabel || ('' as any),
      sistatus2: filterValues.sistatus2 || ('' as any),
      suppliername: filterValues.suppliername || ('' as any),
      tprefclient: filterValues.tprefclient || ('' as any),
      tprefsupplier: filterValues.tprefsupplier || ('' as any),
    };
  };
  const [form] = useForm();

  const initialSearchParams: FindSIByAnyRefOrStatusOrDateParams =
    getSearchParams();
  const [SearchParams, SetSearchParams] =
    useState<FindSIByAnyRefOrStatusOrDateParams>(initialSearchParams);

  // const {
  //   data,
  //   refetch,
  //   isFetching,
  // } = useQuery(
  //   ['findSIByAnyRefOrStatusOrDate', SearchParams],
  //   () =>
  //     findSIByAnyRefOrStatusOrDate(SearchParams).then((res) => res.list || []),
  //   { refetchOnMount: true }
  // );
  
const filterConfig: FilterConfig[] = [
  {
    key: 'N_cars',
    label: 'N° cars',
    type: 'text',
    placeholder: 'Numéro de voiture',
  },
  {
    key: 'VIN1',
    label: 'VIN1',
    type: 'text',
    placeholder: 'VIN1',
  },
  {
    key: 'VIN2',
    label: 'VIN2',
    type: 'text',
    placeholder: 'VIN2',
  },
  {
    key: 'Famille_produit',
    label: 'Famille produit',
    type: 'select', 
    placeholder: 'Choisir la famille produit',
  },
  {
    key: 'RRDI',
    label: 'RRDI',
    type: 'text',
    placeholder: 'Code RRDI',
  },
  {
    key: 'Motif_Refus',
    label: 'Motif de refus',
    type: 'select', 
    placeholder: 'Choisir un motif',
  },
  {
    key: 'Duree_franchise_prevue',
    label: 'Durée de franchise prévue',
    type: 'number',
    placeholder: 'Durée (jours)',
  },
  {
    key: 'Montant_reservation',
    label: 'Montant réservation (€)',
    type: 'number',
    placeholder: 'Montant réservation',
  },
  {
    key: 'Montant_facture',
    label: 'Montant facture (€)',
    type: 'number',
    placeholder: 'Montant facture',
  },
  {
    key: 'Tolerance_%',
    label: 'Tolérance (%)',
    type: 'number',
    placeholder: 'Tolérance',
  },
];


const columns = [
  {
    title: 'N° cars',
    dataIndex: 'N_cars',
    key: 'N_cars',
    width: 150,
  },
  {
    title: 'VIN1',
    dataIndex: 'VIN1',
    key: 'VIN1',
    width: 150,
    render: (value: string) => value || '',
  },
  {
    title: 'VIN2',
    dataIndex: 'VIN2',
    key: 'VIN2',
    width: 150,
    render: (value: string) => value || '',
  },
  {
    title: 'Famille produit',
    dataIndex: 'Famille_produit',
    key: 'Famille_produit',
    width: 150,
  },
  {
    title: 'RRDI',
    dataIndex: 'RRDI',
    key: 'RRDI',
    width: 150,
  },
  {
    title: 'Motif Refus',
    dataIndex: 'Motif_Refus',
    key: 'Motif_Refus',
    width: 200,
  },
  {
    title: 'Durée de franchise prévue',
    dataIndex: 'Duree_franchise_prevue',
    key: 'Duree_franchise_prevue',
    width: 200,
  },
  {
    title: 'Montant réservation (€)',
    dataIndex: 'Montant_reservation',
    key: 'Montant_reservation',
    width: 180,
    render: (value: number) =>
      value?.toLocaleString('fr-FR', { minimumFractionDigits: 0 }),
  },
  {
    title: 'Montant facture (€)',
    dataIndex: 'Montant_facture',
    key: 'Montant_facture',
    width: 180,
    render: (value: number) =>
      value?.toLocaleString('fr-FR', { minimumFractionDigits: 0 }),
  },
  {
    title: 'Tolérance (%)',
    dataIndex: 'Tolerance_%',
    key: 'Tolerance_%',
    width: 120,
    render: (value: number) =>
      value?.toLocaleString('fr-FR', { minimumFractionDigits: 1 }),
  },
   {
      title: '',
      key: 'arrow',
      width: '80px',

      render: (record: any) => (
        <ModalSFS
          className="color-gray"
          trigger={({ setVisible }) => (
            <ArrowRightOutlined
              onClick={() => setVisible(true)}
              style={{
                cursor: 'pointer',
              }}
            />
          )}
          title="anomalymanage"
          footer
          width={560}
        >
          <InvoiceModal
            setVisible={() => false}
            data={record} // Pass the entire row data directly
            refetch={() => {
             // refetch();
            }}
          />
        </ModalSFS>
      ),
      onHeaderCell: () => ({
        style: { paddingLeft: '12px' },
      }),
    },
];


  const onSelectChange = (
    selectedRowKeys: React.Key[],
    selectedRows: any[]
  ) => {
    setSelectedRows(selectedRows);
    setSelectedTaxeCode(selectedRows[0].taxcode);
    console.log(selectedRows);
    setIsDisabled(selectedRows.length === 0);
  };
  const handleFilterSearch = (values: any) => {
    console.log('Filter values:', values);
    SetSearchParams(values);
  };

  const handleFilterReset = () => {
    setFilterValues({});
    form.resetFields();
  };
  return (
    // <DF.Provider pagcode="partaxe">
    <DF.Provider pagcode="parcontrol">
      <div className="bg-color-gray">
        <HeroTitle
          form={form}
          color={color}
          title="InvoiceList"
          showFilter
          display
          filterConfig={filterConfig}
          onFilterSearch={handleFilterSearch}
          onFilterReset={handleFilterReset}
          className="productlist"
          noTitleOverlay
        />

        <div className="ut-title-page no-after globalvision">
          {addTaxeValue && (
            <Row justify="space-between" gutter={16} align="middle">
              <Col span={24}>
                <StatCard
                  title=""
                  value="Veuillez ajouter la valeur du taxe."
                  variant="notif"
                  className="mb-8 staticNotf mt-8"
                  valueStyle={{
                    backgroundColor: '#F7C0A929',
                  }}
                  width="100%"
                />
              </Col>
            </Row>
          )}
          <Row
            justify="space-between"
            align="middle"
            style={{ marginBottom: '15px' }}
          >
            <Col className="d-flex justify-start align-center">
              <Button
                disabled={isDisabled}
                className={
                  !isDisabled
                    ? 'no-border-radius  filter-item ant-btn-outline-primary bg-color-hover'
                    : 'no-border-radius  filter-item '
                }
                onClick={() => {
                  setmodalValidVisible(true);
                }}
              >
                <GetLabel label="validemasse" /> ({selectedRows.length})
              </Button>
               <Button
                disabled={isDisabled}
                className={
                  !isDisabled
                    ? 'no-border-radius  filter-item ant-btn-outline-primary bg-color-hover ml-4'
                    : 'no-border-radius  filter-item ml-4'
                }
                onClick={() => {
                  setModalRejectVisible(true);
                }}
              >
                <GetLabel label="rejectmasse" /> ({selectedRows.length})
              </Button>
             
            </Col>
            <Col span={5} className="d-flex justify-end align-center">
              <ExportXLS data={data || []} filename="Taxes" />
            </Col>
          </Row>

          <DataGrid
            columns={columns}
            dataSource={data}
            rowKey="id"
            hideFilters
            hideTitle
            rowSelection={{
              type: 'checkbox',
              onChange: onSelectChange,
            }}
           // isLoading={isFetching}
           
          />
        </div>
        <ConfirmModal
          visible={modalValidVisible}
          status="error"
          message="Êtes-vous sûr de vouloir valider cette facture ?"
          onConfirm={() => {
             
                 !isInspect && Notifications({
                  status: "success",
                  message: 'Facture validée avec succès',
                  description: "",
                  duration: 3,
                  placement: 'top',
                });
                !isInspect &&setmodalValidVisible(false);
             
            }}
          onCancel={() => !isInspect && setmodalValidVisible(false)}
          className="modalConfirmOrCancel"
        />
          <ConfirmModal
          visible={modalRejectVisible}
          status="error"
          message="Êtes-vous sûr de vouloir rejeter cette facture ?"
          onConfirm={() => {
             
                  !isInspect && Notifications({
                  status: "success",
                  message: 'Facture rejetée avec succès',
                  description: "",
                  duration: 3,
                  placement: 'top',
                });
                !isInspect &&setModalRejectVisible(false);
             
            }}
          onCancel={() => !isInspect && setModalRejectVisible(false)}
          className="modalConfirmOrCancel"
        />
      </div>
    </DF.Provider>
  );
};

export default InvoiceList;

  const data= [
    {
      "id": 1,
      "N_cars": "009632C",
      "VIN1": "VF7SCKFT0",
      "VIN2": "CC072256",
      "Famille_produit": "VN",
      "RRDI": "GBN2060",
      "Motif_Refus": "Anomalie montant",
      "Duree_franchise_prevue": 30,
      "Montant_reservation": 50000,
      "Montant_facture": 50000,
      "Tolerance_%": 0
    },
    {
      "id": 2,
      "N_cars": "009632C",
      "VIN1": "VF7SCKFT0",
      "VIN2": "CC072256",
      "Famille_produit": "VN",
      "RRDI": "GBN2060",
      "Motif_Refus": "Anomalie montant",
      "Duree_franchise_prevue": 30,
      "Montant_reservation": 80000,
      "Montant_facture": 80800,
      "Tolerance_%": 1
    },
    {
      "id": 3,
      "N_cars": "009632C",
      "VIN1": "VF7SCKFT0",
      "VIN2": "CC072256",
      "Famille_produit": "VN",
      "RRDI": "GBN2060",
      "Motif_Refus": "Anomalie montant",
      "Duree_franchise_prevue": 30,
      "Montant_reservation": 120000,
      "Montant_facture": 128400,
      "Tolerance_%": 7
    },
    {
      "id": 4,
      "N_cars": "009632C",
      "VIN1": "VF7SCKFT0",
      "VIN2": "CC072256",
      "Famille_produit": "VN",
      "RRDI": "GBN2060",
      "Motif_Refus": "Anomalie montant",
      "Duree_franchise_prevue": 30,
      "Montant_reservation": 75500,
      "Montant_facture": 75877.5,
      "Tolerance_%": 0.5
    },
    {
      "id": 5,
      "N_cars": "009632C",
      "VIN1": "VF7SCKFT0",
      "VIN2": "CC072256",
      "Famille_produit": "VN",
      "RRDI": "GBN2060",
      "Motif_Refus": "Anomalie montant",
      "Duree_franchise_prevue": 30,
      "Montant_reservation": 50000,
      "Montant_facture": 50000,
      "Tolerance_%": 0
    },
    {
      "id": 6,
      "N_cars": "009632C",
      "VIN1": "VF7SCKFT0",
      "VIN2": "CC072256",
      "Famille_produit": "VN",
      "RRDI": "GBN2060",
      "Motif_Refus": "Nb jours de franchise",
      "Duree_franchise_prevue": 30,
      "Montant_reservation": 50000,
      "Montant_facture": 50000,
      "Tolerance_%": 0
    },
    {
      "id": 7,
      "N_cars": "009632C",
      "VIN1": "VF7SCKFT0",
      "VIN2": "CC072256",
      "Famille_produit": "VN",
      "RRDI": "GBN2060",
      "Motif_Refus": "Nb jours de franchise",
      "Duree_franchise_prevue": 30,
      "Montant_reservation": 50000,
      "Montant_facture": 50000,
      "Tolerance_%": 0
    },
    {
      "id": 8,
      "N_cars": "009632C",
      "VIN1": "VF7SCKFT0",
      "VIN2": "CC072256",
      "Famille_produit": "VN",
      "RRDI": "GBN2060",
      "Motif_Refus": "Anomalie montant",
      "Duree_franchise_prevue": 30,
      "Montant_reservation": 50000,
      "Montant_facture": 50000,
      "Tolerance_%": 0
    },
    {
      "id": 9,
      "N_cars": "009632C",
      "VIN1": "VF7SCKFT0",
      "VIN2": "CC072256",
      "Famille_produit": "VN",
      "RRDI": "GBN2060",
      "Motif_Refus": "Nb jours de franchise",
      "Duree_franchise_prevue": 30,
      "Montant_reservation": 50000,
      "Montant_facture": 50000,
      "Tolerance_%": 0
    },
    {
      "id": 10,
      "N_cars": "009632C",
      "VIN1": "VF7SCKFT0",
      "VIN2": "CC072256",
      "Famille_produit": "VN",
      "RRDI": "GBN2060",
      "Motif_Refus": "Anomalie montant",
      "Duree_franchise_prevue": 30,
      "Montant_reservation": 50000,
      "Montant_facture": 50000,
      "Tolerance_%": 0
    }
  ]


